import uiI18n from "../i18n";
import { useTranslation as useUiTranslation } from "react-i18next";
import { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { getMyReservation, deleteReservation, reservationStatus } from '../Services/reservationService';
export default function Reservation() {
  useUiTranslation();
  const { reservationID } = useParams();
  const [reservation, setReservation] = useState(null);
  const [error, setError] = useState('');
  const [busy, setBusy] = useState(false);
  const [loaded, setLoaded] = useState(false);
  useEffect(() => {
    let active = true;
    getMyReservation(reservationID).then(data => { if(active) setReservation(data); })
      .catch(err => { if(active) setError(err.message); }).finally(() => { if(active) setLoaded(true); });
    return () => { active = false; };
  }, [reservationID]);
  const cancel = async () => {
    if(!window.confirm(uiI18n.t("ui.cancel_this_booking_request"))) return;
    setBusy(true);
    try { await deleteReservation(reservation); setReservation(null); }
    catch(err) { setError(err.message); }
    finally { setBusy(false); }
  };
  return <main className="mx-auto max-w-3xl p-6">
    <h1 className="text-xl font-bold">{uiI18n.t("ui.my_booking")}</h1>
    {error && <p role="alert">{error}</p>}
    {!loaded ? <p>{uiI18n.t("ui.loading_581")}</p> : !reservation ? <p>{uiI18n.t("ui.no_bookings_available")}</p> : <section>
      <h2>{reservation.title}</h2>
      <p>{reservation.arrival} ? {reservation.depart}</p>
      <p>{reservation.nbTraveler} {uiI18n.t("ui.guests_583")} {reservation.total} TND</p>
      <p>{[uiI18n.t("ui.pending"), uiI18n.t("ui.accepted"), uiI18n.t("ui.rejected_585")][reservationStatus(reservation.status)] || uiI18n.t("ui.unknown_status")}</p>
      {reservation.propertyIsDeleted && <p>{uiI18n.t("ui.listing_deleted_587")}</p>}
      {reservationStatus(reservation.status) === 0 && <button disabled={busy} onClick={cancel}>{uiI18n.t("ui.cancel_request")}</button>}
    </section>}
  </main>;
}
